var _defs, _mask, _use, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M43.79 22.438c-1.301 2.924-3.17 5.686-5.557 8.21-3.832 4.053-9.13 7.51-14.233 9.295-5.103-1.786-10.401-5.242-14.233-9.295-2.386-2.524-4.256-5.286-5.557-8.21A25.514 25.514 0 012 12c0-2.47 1.086-4.99 2.981-6.91C6.948 3.099 9.496 2 12.156 2c3.975 0 7.573 1.08 10.13 3.043.096.074.191.15.285.226C20.898 7.215 20 9.537 20 12c0 2.13 1.87 4 4 4s4-1.87 4-4c0-2.463-.898-4.785-2.57-6.731.092-.076.188-.152.284-.226C28.271 3.081 31.868 2 35.844 2c2.66 0 5.208 1.098 7.175 3.09C44.913 7.01 46 9.53 46 12c0 3.63-.744 7.142-2.21 10.438M24 6.679c1.302 1.563 2 3.395 2 5.321 0 .925-.874 2-2 2s-2-1.075-2-2c0-1.926.698-3.758 2-5.32M35.844 0c-4.414 0-8.443 1.228-11.347 3.457-.17.13-.336.264-.497.4-.161-.136-.327-.27-.497-.4C20.6 1.227 16.57 0 12.156 0 8.957 0 5.903 1.31 3.557 3.686 1.297 5.977 0 9.008 0 12c0 7.346 2.875 14.27 8.313 20.022 4.188 4.43 9.79 8.047 15.367 9.926a.997.997 0 00.64 0c5.578-1.88 11.178-5.497 15.366-9.926C45.126 26.269 48 19.346 48 12c0-2.992-1.297-6.023-3.558-8.314C42.096 1.309 39.042 0 35.844 0",
    id: "heart_svg__a"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "heart_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#heart_svg__a"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    fill: "#ED553B",
    xlinkHref: "#heart_svg__a"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#heart_svg__b)",
    fill: props.color
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0-3h48v47.892H0z"
  })))));
}
export default SvgHeart;